import { formatDate } from 'affiny-core/helpers/date';
import {
  IApiAccount,
  IApiOptins,
  IOptinPayload,
} from 'affiny-core/modules/api/models/account/account.types';
import {
  IApiAutoRenewal,
  IApiSubscription,
} from 'affiny-core/modules/api/models/subscription';
import { AffinyEndpoint } from '../affinyEndpoints/affiny.endpoints';

interface IApiAccountResponse {
  data: IApiAccount;
}

export const AccountResource = {
  getMyAccount: async (): Promise<IApiAccount> => {
    const response = await AffinyEndpoint.Account.url('/')
      .get()
      .json<IApiAccountResponse>();

    return response.data;
  },

  getMySubscription: async (): Promise<IApiSubscription> => {
    const response = await AffinyEndpoint.Account.url('/subscriptions/current')
      .get()
      .json();

    return response.data;
  },

  getMyOptins: async (): Promise<IApiOptins> => {
    const response = await AffinyEndpoint.Account.url('/optins').get().json();

    return response.data;
  },

  patchHasCompletedProfile: () =>
    AffinyEndpoint.Account.url('/')
      .patch({
        data: {
          type: 'account',
          attributes: {
            status: 'active',
          },
        },
      })
      .res(),
  patchMyOptin: (optin: IOptinPayload) =>
    AffinyEndpoint.Account.url('/optins')
      .patch({
        data: {
          type: 'optin',
          attributes: {
            ...optin,
          },
        },
      })
      .res(),
  patchCityAndBirthdateProfile: ({
    placeId,
    birthdate,
  }: {
    placeId?: number;
    birthdate: string;
  }) => {
    let attributes: {
      birthdate: string;
      placeId?: number;
    } = { birthdate: formatDate(new Date(birthdate), 'yyyy-MM-dd') };

    if (placeId) {
      attributes = {
        ...attributes,
        placeId,
      };
    }

    return AffinyEndpoint.Account.url('/')
      .patch({
        data: {
          type: 'account',
          attributes,
        },
      })
      .res();
  },
  changeMyPassword: ({
    oldPassword,
    password,
  }: {
    oldPassword: string;
    password: string;
  }) =>
    AffinyEndpoint.Account.url('/password/')
      .put({
        data: {
          type: 'passwordAccount',
          attributes: { password, oldPassword },
        },
      })
      .res(),
  setPicturePrivacy: (privatePicture: boolean) =>
    AffinyEndpoint.Account.url('/')
      .patch({
        data: {
          type: 'account',
          attributes: {
            setting: {
              privatePicture,
            },
          },
        },
      })
      .res(),
  deleteAccount: () =>
    AffinyEndpoint.Account.url('/')
      .json({
        data: {
          attributes: {
            reason: 'unregistration_member_request',
          },
        },
      })
      .delete()
      .res(),

  getMyAutoRenewalStatus: async (): Promise<IApiAutoRenewal> => {
    const response = await AffinyEndpoint.BaseWithAuthentication.url(
      '/auto_renewal/status'
    )
      .get()
      .json();

    return response.data;
  },

  cancelAutoRenewal: (reason: string) =>
    AffinyEndpoint.BaseWithAuthentication.url('/auto_renewal/cancel')
      .post({ reason })
      .res(),

  postReactivateAutoRenewal: () =>
    AffinyEndpoint.BaseWithAuthentication.url('/auto_renewal/reactivate')
      .post()
      .res(),
};
